import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_MORE_FROM_THIS_BRAND_PRODUCTS = apiPromiseTypes(
  'products-more-from-this-brand',
  'get',
);
